export type ITranslateFile = Record<string, string>;

export enum ELocale {
  ARABIC = 'ar',
  CATALONIAN = 'ca',
  CHINESE = 'zh_CN',
  GUJARATI = 'guj',
  DUTCH = 'nl',
  ENGLISH_GB = 'en_GB',
  ENGLISH_US = 'en_US',
  FRENCH = 'fr',
  GERMAN = 'de',
  ITALIAN = 'it',
  NORWEGIAN = 'no',
  NORWEGIAN_NB = 'nb',
  SPANISH = 'es',
  SPANISH_US = 'es_US',
  SWEDISH = 'sv',
  JAPANESE = 'ja',
  HINDI = 'hindi',
}

export const CUSTOM_LOCALE_FILES: ITranslateFile = {
  [ELocale.ARABIC]: 'ar',
  [ELocale.CATALONIAN]: 'ca',
  [ELocale.CHINESE]: 'zh_CN',
  [ELocale.DUTCH]: 'nl',
  [ELocale.ENGLISH_GB]: 'en_GB',
  [ELocale.ENGLISH_US]: 'en_US',
  [ELocale.FRENCH]: 'fr',
  [ELocale.GERMAN]: 'de',
  [ELocale.ITALIAN]: 'it_IT',
  [ELocale.NORWEGIAN]: 'no',
  [ELocale.NORWEGIAN_NB]: 'nb',
  [ELocale.SPANISH]: 'es',
  [ELocale.SPANISH_US]: 'es_US',
  [ELocale.SWEDISH]: 'sv',
  [ELocale.JAPANESE]: 'ja',
  [ELocale.GUJARATI]: 'guj',
  [ELocale.HINDI]: 'hindi',
};

export const geSupportedBrowserLocale = (locale: string) => {
  const currentLocale = locale.split('-')[0] || 'en';
  const supportedLocales = Object.keys(CUSTOM_LOCALE_FILES).map(
    (key) => key.split('_')[0],
  );

  return supportedLocales.includes(currentLocale) ? locale : 'en-GB';
};

export const RTLLocales = [ELocale.ARABIC];
